// extracted by mini-css-extract-plugin
export default {"page":"Students_page__EIkXX","container":"Students_container__XcGkv","header":"Students_header__8Mzpy","bar":"Students_bar__0qttj","table":"Students_table__BVxYn"};